export const GET_USER_ME_START = "@users/GET_USER_ME_START";
export const GET_USER_ME_SUCCESS = "@users/GET_USER_ME_SUCCESS";
export const GET_USER_ME_FAILED = "@users/GET_USER_ME_FAILED";
export const GET_DETAIL_START = "@users/GET_DETAIL_START";
export const GET_DETAIL_SUCCESS = "@users/GET_DETAIL_SUCCESS";
export const GET_DETAIL_FAILED = "@users/GET_DETAIL_FAILED";
